import * as i0 from '@angular/core';
import { InjectionToken, Component, ViewEncapsulation, ChangeDetectionStrategy, Injectable, Optional, Inject, Directive, Input, EventEmitter, Host, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@ng-dot/core';
import { ClassSwitch } from '@js-dot/ui';
import { Bulk } from '@js-dot/core';
import * as i4 from '@ng-dot/ux/color';
import { DotColorDirective } from '@ng-dot/ux/color';
import * as i6 from '@ng-dot/ui/ripple';
import { DotRippleDirective } from '@ng-dot/ui/ripple';
import * as i7 from '@ng-dot/ui/tip';
import { DotTipDirective } from '@ng-dot/ui/tip';
import * as i5 from '@ng-dot/ux/up';
import { DotUpDirective } from '@ng-dot/ux/up';
import * as i3 from '@ng-dot/ux/shape';
import { DotShapeDirective } from '@ng-dot/ux/shape';
import * as i1$1 from '@ng-dot/ux/zone';
import { CommonModule } from '@angular/common';
const _c0 = ["dot-link", ""];
const _c1 = ["*"];
function DotLinkComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.innerHTML, i0.ɵɵsanitizeHtml);
  }
}
function DotLinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.textContent);
  }
}
function DotLinkComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
const DOT_LINK_MODULE_CONFIGURE = new InjectionToken('#ng-dot/ui/link/module-configure');
class DotLinkBoldStyleComponent {
  static ɵfac = function DotLinkBoldStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkBoldStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLinkBoldStyleComponent,
    selectors: [["dot-link-bold-style"]],
    decls: 0,
    vars: 0,
    template: function DotLinkBoldStyleComponent_Template(rf, ctx) {},
    styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-bolds .dot-link:not([class*=link_]),.dot-link.link_bold{--link-back:var(--t);--link-text:var(--b);background-size:200%}.dot-link-bolds .dot-link:not([class*=link_]):hover,.dot-link.link_bold:hover{--link-back:var(--m);--link-text:var(--m-text)}.dot-link-bolds .dot-link:not([class*=link_])._main,.dot-link.link_bold._main{--link-text:var(--m-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--m), var(--m-16d), var(--m))!important}.dot-link-bolds .dot-link:not([class*=link_])._main:hover,.dot-link.link_bold._main:hover{--link-back:var(--m-32d)}.dot-link-bolds .dot-link:not([class*=link_])._sub,.dot-link.link_bold._sub{--link-text:var(--s-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--s), var(--s-16d), var(--s))!important}.dot-link-bolds .dot-link:not([class*=link_])._sub:hover,.dot-link.link_bold._sub:hover{--link-back:var(--s-32d)}.dot-link-bolds .dot-link:not([class*=link_])._point,.dot-link.link_bold._point{--link-text:var(--p-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--p), var(--p-16d), var(--p))!important}.dot-link-bolds .dot-link:not([class*=link_])._point:hover,.dot-link.link_bold._point:hover{--link-back:var(--p-32d)}.dot-link-bolds .dot-link:not([class*=link_])._warn,.dot-link.link_bold._warn{--link-text:var(--w-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--w), var(--w-16d), var(--w))!important}.dot-link-bolds .dot-link:not([class*=link_])._warn:hover,.dot-link.link_bold._warn:hover{--link-back:var(--w-32d)}.dot-link-bolds .dot-link:not([class*=link_])._active,.dot-link.link_bold._active{animation:gd-right .92s infinite linear both}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkBoldStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-link-bold-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-bolds .dot-link:not([class*=link_]),.dot-link.link_bold{--link-back:var(--t);--link-text:var(--b);background-size:200%}.dot-link-bolds .dot-link:not([class*=link_]):hover,.dot-link.link_bold:hover{--link-back:var(--m);--link-text:var(--m-text)}.dot-link-bolds .dot-link:not([class*=link_])._main,.dot-link.link_bold._main{--link-text:var(--m-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--m), var(--m-16d), var(--m))!important}.dot-link-bolds .dot-link:not([class*=link_])._main:hover,.dot-link.link_bold._main:hover{--link-back:var(--m-32d)}.dot-link-bolds .dot-link:not([class*=link_])._sub,.dot-link.link_bold._sub{--link-text:var(--s-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--s), var(--s-16d), var(--s))!important}.dot-link-bolds .dot-link:not([class*=link_])._sub:hover,.dot-link.link_bold._sub:hover{--link-back:var(--s-32d)}.dot-link-bolds .dot-link:not([class*=link_])._point,.dot-link.link_bold._point{--link-text:var(--p-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--p), var(--p-16d), var(--p))!important}.dot-link-bolds .dot-link:not([class*=link_])._point:hover,.dot-link.link_bold._point:hover{--link-back:var(--p-32d)}.dot-link-bolds .dot-link:not([class*=link_])._warn,.dot-link.link_bold._warn{--link-text:var(--w-text)!important;--link-back:linear-gradient(var(--link-back-deg), var(--w), var(--w-16d), var(--w))!important}.dot-link-bolds .dot-link:not([class*=link_])._warn:hover,.dot-link.link_bold._warn:hover{--link-back:var(--w-32d)}.dot-link-bolds .dot-link:not([class*=link_])._active,.dot-link.link_bold._active{animation:gd-right .92s infinite linear both}\n"]
    }]
  }], null, null);
})();
class DotLinkGhostStyleComponent {
  static ɵfac = function DotLinkGhostStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkGhostStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLinkGhostStyleComponent,
    selectors: [["dot-link-ghost-style"]],
    decls: 0,
    vars: 0,
    template: function DotLinkGhostStyleComponent_Template(rf, ctx) {},
    styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-ghosts .dot-link:not([class*=link_]),.dot-link.link_ghost{--link-back:transparent;--link-text:currentColor;--link-borders:solid 2px currentColor}.dot-link-ghosts .dot-link:not([class*=link_])._active,.dot-link.link_ghost._active{animation:bIYnXirOAzdzPnuWY6wdvrFK12W2RwaR 1.2s infinite linear}@keyframes bIYnXirOAzdzPnuWY6wdvrFK12W2RwaR{50%{background-color:var(--t4a)}}.dot-link-ghosts .dot-link:not([class*=link_])._main,.dot-link.link_ghost._main{--link-text:var(--m)}.dot-link-ghosts .dot-link:not([class*=link_])._main:hover,.dot-link.link_ghost._main:hover{--link-text:var(--m-32d);--link-back:transparent;border-color:var(--m-32d)}.dot-link-ghosts .dot-link:not([class*=link_])._main._active,.dot-link.link_ghost._main._active{animation:lm0WHEPtByXSfm5gBroguKu7tY0Nffev 1.2s infinite linear}@keyframes lm0WHEPtByXSfm5gBroguKu7tY0Nffev{50%{background-color:var(--m8a)}}.dot-link-ghosts .dot-link:not([class*=link_])._point,.dot-link.link_ghost._point{--link-text:var(--p)}.dot-link-ghosts .dot-link:not([class*=link_])._point:hover,.dot-link.link_ghost._point:hover{--link-text:var(--p-32d);--link-back:transparent;border-color:var(--p-32d)}.dot-link-ghosts .dot-link:not([class*=link_])._point._active,.dot-link.link_ghost._point._active{animation:nNaJHRT3OTyzO2oetQ9hefuabEpE6Wfx 1.2s infinite linear}@keyframes nNaJHRT3OTyzO2oetQ9hefuabEpE6Wfx{50%{background-color:var(--p8a)}}.dot-link-ghosts .dot-link:not([class*=link_])._warn,.dot-link.link_ghost._warn{--link-text:var(--w)}.dot-link-ghosts .dot-link:not([class*=link_])._warn:hover,.dot-link.link_ghost._warn:hover{--link-text:var(--w-32d);--link-back:transparent;border-color:var(--w-32d)}.dot-link-ghosts .dot-link:not([class*=link_])._warn._active,.dot-link.link_ghost._warn._active{animation:j2tmRi91NYURtWzsgbP9meLcmfvfOw6h 1.2s infinite linear}@keyframes j2tmRi91NYURtWzsgbP9meLcmfvfOw6h{50%{background-color:var(--w8a)}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkGhostStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-link-ghost-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-ghosts .dot-link:not([class*=link_]),.dot-link.link_ghost{--link-back:transparent;--link-text:currentColor;--link-borders:solid 2px currentColor}.dot-link-ghosts .dot-link:not([class*=link_])._active,.dot-link.link_ghost._active{animation:bIYnXirOAzdzPnuWY6wdvrFK12W2RwaR 1.2s infinite linear}@keyframes bIYnXirOAzdzPnuWY6wdvrFK12W2RwaR{50%{background-color:var(--t4a)}}.dot-link-ghosts .dot-link:not([class*=link_])._main,.dot-link.link_ghost._main{--link-text:var(--m)}.dot-link-ghosts .dot-link:not([class*=link_])._main:hover,.dot-link.link_ghost._main:hover{--link-text:var(--m-32d);--link-back:transparent;border-color:var(--m-32d)}.dot-link-ghosts .dot-link:not([class*=link_])._main._active,.dot-link.link_ghost._main._active{animation:lm0WHEPtByXSfm5gBroguKu7tY0Nffev 1.2s infinite linear}@keyframes lm0WHEPtByXSfm5gBroguKu7tY0Nffev{50%{background-color:var(--m8a)}}.dot-link-ghosts .dot-link:not([class*=link_])._point,.dot-link.link_ghost._point{--link-text:var(--p)}.dot-link-ghosts .dot-link:not([class*=link_])._point:hover,.dot-link.link_ghost._point:hover{--link-text:var(--p-32d);--link-back:transparent;border-color:var(--p-32d)}.dot-link-ghosts .dot-link:not([class*=link_])._point._active,.dot-link.link_ghost._point._active{animation:nNaJHRT3OTyzO2oetQ9hefuabEpE6Wfx 1.2s infinite linear}@keyframes nNaJHRT3OTyzO2oetQ9hefuabEpE6Wfx{50%{background-color:var(--p8a)}}.dot-link-ghosts .dot-link:not([class*=link_])._warn,.dot-link.link_ghost._warn{--link-text:var(--w)}.dot-link-ghosts .dot-link:not([class*=link_])._warn:hover,.dot-link.link_ghost._warn:hover{--link-text:var(--w-32d);--link-back:transparent;border-color:var(--w-32d)}.dot-link-ghosts .dot-link:not([class*=link_])._warn._active,.dot-link.link_ghost._warn._active{animation:j2tmRi91NYURtWzsgbP9meLcmfvfOw6h 1.2s infinite linear}@keyframes j2tmRi91NYURtWzsgbP9meLcmfvfOw6h{50%{background-color:var(--w8a)}}\n"]
    }]
  }], null, null);
})();
class DotLinkHardStyleComponent {
  static ɵfac = function DotLinkHardStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkHardStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLinkHardStyleComponent,
    selectors: [["dot-link-hard-style"]],
    decls: 0,
    vars: 0,
    template: function DotLinkHardStyleComponent_Template(rf, ctx) {},
    styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-hards .dot-link:not([class*=link_]),.dot-link.link_hard{--link-back: var(--t);--link-text: var(--b) }.dot-link-hards .dot-link:not([class*=link_]):hover,.dot-link.link_hard:hover{--link-text: var(--m-text);--link-back: var(--m) }.dot-link-hards .dot-link:not([class*=link_])._active,.dot-link.link_hard._active{--link-text: var(--m-text);--link-back: var(--m) }.dot-link-hards .dot-link:not([class*=link_])._main,.dot-link.link_hard._main{--link-text: var(--m-text);--link-back: var(--m) }.dot-link-hards .dot-link:not([class*=link_])._main:hover,.dot-link.link_hard._main:hover{--link-back: var(--m16) }.dot-link-hards .dot-link:not([class*=link_])._main._active,.dot-link-hards .dot-link:not([class*=link_])._main._active:hover,.dot-link.link_hard._main._active,.dot-link.link_hard._main._active:hover{animation:iwxJKHOPCwW1nwmRwELaTeW1HMpRq9RH .92s infinite}@keyframes iwxJKHOPCwW1nwmRwELaTeW1HMpRq9RH{50%{background:var(--m-16d)}}.dot-link-hards .dot-link:not([class*=link_])._sub,.dot-link.link_hard._sub{--link-text: var(--s-text);--link-back: var(--s) }.dot-link-hards .dot-link:not([class*=link_])._sub:hover,.dot-link.link_hard._sub:hover{--link-back: var(--s16) }.dot-link-hards .dot-link:not([class*=link_])._sub._active,.dot-link-hards .dot-link:not([class*=link_])._sub._active:hover,.dot-link.link_hard._sub._active,.dot-link.link_hard._sub._active:hover{animation:zpp9WTQ71nCXjIL6PxuLpewuLVMbh97N .92s infinite}@keyframes zpp9WTQ71nCXjIL6PxuLpewuLVMbh97N{50%{background:var(--s-16d)}}.dot-link-hards .dot-link:not([class*=link_])._point,.dot-link.link_hard._point{--link-text: var(--p-text);--link-back: var(--p) }.dot-link-hards .dot-link:not([class*=link_])._point:hover,.dot-link.link_hard._point:hover{--link-back: var(--p16) }.dot-link-hards .dot-link:not([class*=link_])._point._active,.dot-link-hards .dot-link:not([class*=link_])._point._active:hover,.dot-link.link_hard._point._active,.dot-link.link_hard._point._active:hover{animation:esjrEFnkmnCjE6tHIvmYnasKusjkeKFa .92s infinite}@keyframes esjrEFnkmnCjE6tHIvmYnasKusjkeKFa{50%{background:var(--p-16d)}}.dot-link-hards .dot-link:not([class*=link_])._warn,.dot-link.link_hard._warn{--link-text: var(--w-text);--link-back: var(--w) }.dot-link-hards .dot-link:not([class*=link_])._warn:hover,.dot-link.link_hard._warn:hover{--link-back: var(--w16) }.dot-link-hards .dot-link:not([class*=link_])._warn._active,.dot-link-hards .dot-link:not([class*=link_])._warn._active:hover,.dot-link.link_hard._warn._active,.dot-link.link_hard._warn._active:hover{animation:Hh9LaIA987tI91dr9avBOHS5rSp9JdQd .92s infinite}@keyframes Hh9LaIA987tI91dr9avBOHS5rSp9JdQd{50%{background:var(--w-16d)}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkHardStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-link-hard-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-hards .dot-link:not([class*=link_]),.dot-link.link_hard{--link-back: var(--t);--link-text: var(--b) }.dot-link-hards .dot-link:not([class*=link_]):hover,.dot-link.link_hard:hover{--link-text: var(--m-text);--link-back: var(--m) }.dot-link-hards .dot-link:not([class*=link_])._active,.dot-link.link_hard._active{--link-text: var(--m-text);--link-back: var(--m) }.dot-link-hards .dot-link:not([class*=link_])._main,.dot-link.link_hard._main{--link-text: var(--m-text);--link-back: var(--m) }.dot-link-hards .dot-link:not([class*=link_])._main:hover,.dot-link.link_hard._main:hover{--link-back: var(--m16) }.dot-link-hards .dot-link:not([class*=link_])._main._active,.dot-link-hards .dot-link:not([class*=link_])._main._active:hover,.dot-link.link_hard._main._active,.dot-link.link_hard._main._active:hover{animation:iwxJKHOPCwW1nwmRwELaTeW1HMpRq9RH .92s infinite}@keyframes iwxJKHOPCwW1nwmRwELaTeW1HMpRq9RH{50%{background:var(--m-16d)}}.dot-link-hards .dot-link:not([class*=link_])._sub,.dot-link.link_hard._sub{--link-text: var(--s-text);--link-back: var(--s) }.dot-link-hards .dot-link:not([class*=link_])._sub:hover,.dot-link.link_hard._sub:hover{--link-back: var(--s16) }.dot-link-hards .dot-link:not([class*=link_])._sub._active,.dot-link-hards .dot-link:not([class*=link_])._sub._active:hover,.dot-link.link_hard._sub._active,.dot-link.link_hard._sub._active:hover{animation:zpp9WTQ71nCXjIL6PxuLpewuLVMbh97N .92s infinite}@keyframes zpp9WTQ71nCXjIL6PxuLpewuLVMbh97N{50%{background:var(--s-16d)}}.dot-link-hards .dot-link:not([class*=link_])._point,.dot-link.link_hard._point{--link-text: var(--p-text);--link-back: var(--p) }.dot-link-hards .dot-link:not([class*=link_])._point:hover,.dot-link.link_hard._point:hover{--link-back: var(--p16) }.dot-link-hards .dot-link:not([class*=link_])._point._active,.dot-link-hards .dot-link:not([class*=link_])._point._active:hover,.dot-link.link_hard._point._active,.dot-link.link_hard._point._active:hover{animation:esjrEFnkmnCjE6tHIvmYnasKusjkeKFa .92s infinite}@keyframes esjrEFnkmnCjE6tHIvmYnasKusjkeKFa{50%{background:var(--p-16d)}}.dot-link-hards .dot-link:not([class*=link_])._warn,.dot-link.link_hard._warn{--link-text: var(--w-text);--link-back: var(--w) }.dot-link-hards .dot-link:not([class*=link_])._warn:hover,.dot-link.link_hard._warn:hover{--link-back: var(--w16) }.dot-link-hards .dot-link:not([class*=link_])._warn._active,.dot-link-hards .dot-link:not([class*=link_])._warn._active:hover,.dot-link.link_hard._warn._active,.dot-link.link_hard._warn._active:hover{animation:Hh9LaIA987tI91dr9avBOHS5rSp9JdQd .92s infinite}@keyframes Hh9LaIA987tI91dr9avBOHS5rSp9JdQd{50%{background:var(--w-16d)}}\n"]
    }]
  }], null, null);
})();
class DotLinkLineStyleComponent {
  static ɵfac = function DotLinkLineStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkLineStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLinkLineStyleComponent,
    selectors: [["dot-link-line-style"]],
    decls: 0,
    vars: 0,
    template: function DotLinkLineStyleComponent_Template(rf, ctx) {},
    styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-lines .dot-link:not([class*=link_]),.dot-link.link_line{--link-back:transparent;--link-text:currentColor;--link-borders:solid 2px currentColor;border-width:0 0 2px 0}.dot-link-lines .dot-link:not([class*=link_])._main,.dot-link.link_line._main{--link-text:var(--m)}.dot-link-lines .dot-link:not([class*=link_])._main:hover,.dot-link.link_line._main:hover{--link-text:var(--m-32d);--link-back:transparent;border-color:var(--m-32d)}.dot-link-lines .dot-link:not([class*=link_])._main._active,.dot-link.link_line._main._active{animation:kR16Tn1SrXgl8jYAGkR1qQ9XdwBGTRUz 1.2s infinite linear}@keyframes kR16Tn1SrXgl8jYAGkR1qQ9XdwBGTRUz{50%{background-color:var(--m8a)}}.dot-link-lines .dot-link:not([class*=link_])._point,.dot-link.link_line._point{--link-text:var(--p)}.dot-link-lines .dot-link:not([class*=link_])._point:hover,.dot-link.link_line._point:hover{--link-text:var(--p-32d);--link-back:transparent;border-color:var(--p-32d)}.dot-link-lines .dot-link:not([class*=link_])._point._active,.dot-link.link_line._point._active{animation:yDO8wTuoIYB1P7DOa4Wq7NQPEZ5BOkA8 1.2s infinite linear}@keyframes yDO8wTuoIYB1P7DOa4Wq7NQPEZ5BOkA8{50%{background-color:var(--p8a)}}.dot-link-lines .dot-link:not([class*=link_])._warn,.dot-link.link_line._warn{--link-text:var(--w)}.dot-link-lines .dot-link:not([class*=link_])._warn:hover,.dot-link.link_line._warn:hover{--link-text:var(--w-32d);--link-back:transparent;border-color:var(--w-32d)}.dot-link-lines .dot-link:not([class*=link_])._warn._active,.dot-link.link_line._warn._active{animation:EKQgm2sRLFJdXuKfE9LKJoaBFxDguWEM 1.2s infinite linear}@keyframes EKQgm2sRLFJdXuKfE9LKJoaBFxDguWEM{50%{background-color:var(--w8a)}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkLineStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-link-line-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-lines .dot-link:not([class*=link_]),.dot-link.link_line{--link-back:transparent;--link-text:currentColor;--link-borders:solid 2px currentColor;border-width:0 0 2px 0}.dot-link-lines .dot-link:not([class*=link_])._main,.dot-link.link_line._main{--link-text:var(--m)}.dot-link-lines .dot-link:not([class*=link_])._main:hover,.dot-link.link_line._main:hover{--link-text:var(--m-32d);--link-back:transparent;border-color:var(--m-32d)}.dot-link-lines .dot-link:not([class*=link_])._main._active,.dot-link.link_line._main._active{animation:kR16Tn1SrXgl8jYAGkR1qQ9XdwBGTRUz 1.2s infinite linear}@keyframes kR16Tn1SrXgl8jYAGkR1qQ9XdwBGTRUz{50%{background-color:var(--m8a)}}.dot-link-lines .dot-link:not([class*=link_])._point,.dot-link.link_line._point{--link-text:var(--p)}.dot-link-lines .dot-link:not([class*=link_])._point:hover,.dot-link.link_line._point:hover{--link-text:var(--p-32d);--link-back:transparent;border-color:var(--p-32d)}.dot-link-lines .dot-link:not([class*=link_])._point._active,.dot-link.link_line._point._active{animation:yDO8wTuoIYB1P7DOa4Wq7NQPEZ5BOkA8 1.2s infinite linear}@keyframes yDO8wTuoIYB1P7DOa4Wq7NQPEZ5BOkA8{50%{background-color:var(--p8a)}}.dot-link-lines .dot-link:not([class*=link_])._warn,.dot-link.link_line._warn{--link-text:var(--w)}.dot-link-lines .dot-link:not([class*=link_])._warn:hover,.dot-link.link_line._warn:hover{--link-text:var(--w-32d);--link-back:transparent;border-color:var(--w-32d)}.dot-link-lines .dot-link:not([class*=link_])._warn._active,.dot-link.link_line._warn._active{animation:EKQgm2sRLFJdXuKfE9LKJoaBFxDguWEM 1.2s infinite linear}@keyframes EKQgm2sRLFJdXuKfE9LKJoaBFxDguWEM{50%{background-color:var(--w8a)}}\n"]
    }]
  }], null, null);
})();
class DotLinkSoftStyleComponent {
  static ɵfac = function DotLinkSoftStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkSoftStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLinkSoftStyleComponent,
    selectors: [["dot-link-soft-style"]],
    decls: 0,
    vars: 0,
    template: function DotLinkSoftStyleComponent_Template(rf, ctx) {},
    styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-softs .dot-link:not([class*=link_]),.dot-link.link_soft{--link-back:var(--t4a)}.dot-link-softs .dot-link:not([class*=link_]):hover,.dot-link.link_soft:hover{--link-back:var(--t8a)}.dot-link-softs .dot-link:not([class*=link_])._main,.dot-link.link_soft._main{--link-back:var(--m8a)}.dot-link-softs .dot-link:not([class*=link_])._main:focus,.dot-link.link_soft._main:focus{--link-back:var(--m16a)}.dot-link-softs .dot-link:not([class*=link_])._main:hover,.dot-link.link_soft._main:hover{--link-back:var(--m16a)}.dot-link-softs .dot-link:not([class*=link_])._main._active,.dot-link.link_soft._main._active{animation:EWmC3YWvdIObYNE7a37ZSrZN0Don0QG2 1.2s infinite linear both}@keyframes EWmC3YWvdIObYNE7a37ZSrZN0Don0QG2{50%{color:var(--m32d)}}.dot-link-softs .dot-link:not([class*=link_])._point,.dot-link.link_soft._point{--link-back:var(--p8a)}.dot-link-softs .dot-link:not([class*=link_])._point:focus,.dot-link.link_soft._point:focus{--link-back:var(--p16a)}.dot-link-softs .dot-link:not([class*=link_])._point:hover,.dot-link.link_soft._point:hover{--link-back:var(--p16a)}.dot-link-softs .dot-link:not([class*=link_])._point._active,.dot-link.link_soft._point._active{animation:RWHqNLYT4sp1gIlDYQDTlg6uvjsTXqN5 1.2s infinite linear both}@keyframes RWHqNLYT4sp1gIlDYQDTlg6uvjsTXqN5{50%{color:var(--p32d)}}.dot-link-softs .dot-link:not([class*=link_])._warn,.dot-link.link_soft._warn{--link-back:var(--w8a)}.dot-link-softs .dot-link:not([class*=link_])._warn:focus,.dot-link.link_soft._warn:focus{--link-back:var(--w16a)}.dot-link-softs .dot-link:not([class*=link_])._warn:hover,.dot-link.link_soft._warn:hover{--link-back:var(--w16a)}.dot-link-softs .dot-link:not([class*=link_])._warn._active,.dot-link.link_soft._warn._active{animation:Q5Ld0fjly0otPNwdPJz3rzvlKwDvb4Rk 1.2s infinite linear both}@keyframes Q5Ld0fjly0otPNwdPJz3rzvlKwDvb4Rk{50%{color:var(--w32d)}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkSoftStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-link-soft-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-softs .dot-link:not([class*=link_]),.dot-link.link_soft{--link-back:var(--t4a)}.dot-link-softs .dot-link:not([class*=link_]):hover,.dot-link.link_soft:hover{--link-back:var(--t8a)}.dot-link-softs .dot-link:not([class*=link_])._main,.dot-link.link_soft._main{--link-back:var(--m8a)}.dot-link-softs .dot-link:not([class*=link_])._main:focus,.dot-link.link_soft._main:focus{--link-back:var(--m16a)}.dot-link-softs .dot-link:not([class*=link_])._main:hover,.dot-link.link_soft._main:hover{--link-back:var(--m16a)}.dot-link-softs .dot-link:not([class*=link_])._main._active,.dot-link.link_soft._main._active{animation:EWmC3YWvdIObYNE7a37ZSrZN0Don0QG2 1.2s infinite linear both}@keyframes EWmC3YWvdIObYNE7a37ZSrZN0Don0QG2{50%{color:var(--m32d)}}.dot-link-softs .dot-link:not([class*=link_])._point,.dot-link.link_soft._point{--link-back:var(--p8a)}.dot-link-softs .dot-link:not([class*=link_])._point:focus,.dot-link.link_soft._point:focus{--link-back:var(--p16a)}.dot-link-softs .dot-link:not([class*=link_])._point:hover,.dot-link.link_soft._point:hover{--link-back:var(--p16a)}.dot-link-softs .dot-link:not([class*=link_])._point._active,.dot-link.link_soft._point._active{animation:RWHqNLYT4sp1gIlDYQDTlg6uvjsTXqN5 1.2s infinite linear both}@keyframes RWHqNLYT4sp1gIlDYQDTlg6uvjsTXqN5{50%{color:var(--p32d)}}.dot-link-softs .dot-link:not([class*=link_])._warn,.dot-link.link_soft._warn{--link-back:var(--w8a)}.dot-link-softs .dot-link:not([class*=link_])._warn:focus,.dot-link.link_soft._warn:focus{--link-back:var(--w16a)}.dot-link-softs .dot-link:not([class*=link_])._warn:hover,.dot-link.link_soft._warn:hover{--link-back:var(--w16a)}.dot-link-softs .dot-link:not([class*=link_])._warn._active,.dot-link.link_soft._warn._active{animation:Q5Ld0fjly0otPNwdPJz3rzvlKwDvb4Rk 1.2s infinite linear both}@keyframes Q5Ld0fjly0otPNwdPJz3rzvlKwDvb4Rk{50%{color:var(--w32d)}}\n"]
    }]
  }], null, null);
})();
class DotLinkVividStyleComponent {
  static ɵfac = function DotLinkVividStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkVividStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLinkVividStyleComponent,
    selectors: [["dot-link-vivid-style"]],
    decls: 0,
    vars: 0,
    template: function DotLinkVividStyleComponent_Template(rf, ctx) {},
    styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-vivids .dot-link:not([class*=link_]),.dot-link.link_vivid{--link-back:var(--t);--link-text:var(--b);background-size:200%}.dot-link-vivids .dot-link:not([class*=link_]):hover,.dot-link.link_vivid:hover{--link-text:var(--m-text);--link-back:var(--m)}.dot-link-vivids .dot-link:not([class*=link_])._main,.dot-link.link_vivid._main{--link-text:var(--m-text);--link-back:linear-gradient(var(--link-back-deg), var(--m-48d), var(--m32d), var(--m-48d))}.dot-link-vivids .dot-link:not([class*=link_])._main:hover,.dot-link.link_vivid._main:hover{--link-back:var(--m-48d)}.dot-link-vivids .dot-link:not([class*=link_])._sub,.dot-link.link_vivid._sub{--link-text:var(--s-text);--link-back:linear-gradient(var(--link-back-deg), var(--s-48d), var(--s32d), var(--s-48d))}.dot-link-vivids .dot-link:not([class*=link_])._sub:hover,.dot-link.link_vivid._sub:hover{--link-back:var(--s-48d)}.dot-link-vivids .dot-link:not([class*=link_])._point,.dot-link.link_vivid._point{--link-text:var(--p-text);--link-back:linear-gradient(var(--link-back-deg), var(--p-48d), var(--p32d), var(--p-48d))}.dot-link-vivids .dot-link:not([class*=link_])._point:hover,.dot-link.link_vivid._point:hover{--link-back:var(--p-48d)}.dot-link-vivids .dot-link:not([class*=link_])._warn,.dot-link.link_vivid._warn{--link-text:var(--w-text);--link-back:linear-gradient(var(--link-back-deg), var(--w-48d), var(--w32d), var(--w-48d))}.dot-link-vivids .dot-link:not([class*=link_])._warn:hover,.dot-link.link_vivid._warn:hover{--link-back:var(--w-48d)}.dot-link-vivids .dot-link:not([class*=link_])._active,.dot-link.link_vivid._active{animation:link-gd-right .92s infinite linear both}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkVividStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-link-vivid-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}.dot-link-vivids .dot-link:not([class*=link_]),.dot-link.link_vivid{--link-back:var(--t);--link-text:var(--b);background-size:200%}.dot-link-vivids .dot-link:not([class*=link_]):hover,.dot-link.link_vivid:hover{--link-text:var(--m-text);--link-back:var(--m)}.dot-link-vivids .dot-link:not([class*=link_])._main,.dot-link.link_vivid._main{--link-text:var(--m-text);--link-back:linear-gradient(var(--link-back-deg), var(--m-48d), var(--m32d), var(--m-48d))}.dot-link-vivids .dot-link:not([class*=link_])._main:hover,.dot-link.link_vivid._main:hover{--link-back:var(--m-48d)}.dot-link-vivids .dot-link:not([class*=link_])._sub,.dot-link.link_vivid._sub{--link-text:var(--s-text);--link-back:linear-gradient(var(--link-back-deg), var(--s-48d), var(--s32d), var(--s-48d))}.dot-link-vivids .dot-link:not([class*=link_])._sub:hover,.dot-link.link_vivid._sub:hover{--link-back:var(--s-48d)}.dot-link-vivids .dot-link:not([class*=link_])._point,.dot-link.link_vivid._point{--link-text:var(--p-text);--link-back:linear-gradient(var(--link-back-deg), var(--p-48d), var(--p32d), var(--p-48d))}.dot-link-vivids .dot-link:not([class*=link_])._point:hover,.dot-link.link_vivid._point:hover{--link-back:var(--p-48d)}.dot-link-vivids .dot-link:not([class*=link_])._warn,.dot-link.link_vivid._warn{--link-text:var(--w-text);--link-back:linear-gradient(var(--link-back-deg), var(--w-48d), var(--w32d), var(--w-48d))}.dot-link-vivids .dot-link:not([class*=link_])._warn:hover,.dot-link.link_vivid._warn:hover{--link-back:var(--w-48d)}.dot-link-vivids .dot-link:not([class*=link_])._active,.dot-link.link_vivid._active{animation:link-gd-right .92s infinite linear both}\n"]
    }]
  }], null, null);
})();
class DotLinkService {
  _injector;
  _component;
  _added = [];
  configure;
  constructor(_injector, _component, configure) {
    this._injector = _injector;
    this._component = _component;
    configure = {
      zones: {},
      aliases: {},
      ...(configure || {})
    };
    const {
      zones
    } = configure;
    for (let zoneName in zones) {
      if (!zones.hasOwnProperty(zoneName)) {
        continue;
      }
      const zone = zones[zoneName];
      if (typeof zone === 'string') {
        zones[zoneName] = {
          shape: zone
        };
      }
    }
    this.configure = configure;
  }
  add(shape) {
    const {
      _added
    } = this;
    if (_added.includes(shape)) {
      return null;
    }
    _added[_added.length] = shape;
    const {
      _component
    } = this;
    switch (shape) {
      case 'clear':
        return;
      case 'soft':
        _component.append(DotLinkSoftStyleComponent);
        return;
      case 'hard':
        _component.append(DotLinkHardStyleComponent);
        return;
      case 'bold':
        _component.append(DotLinkBoldStyleComponent);
        return;
      case 'vivid':
        _component.append(DotLinkVividStyleComponent);
        return;
      case 'ghost':
        _component.append(DotLinkGhostStyleComponent);
        return;
      case 'line':
        _component.append(DotLinkLineStyleComponent);
        return;
    }
    console.debug(`[ng.link] Invalid Link Shape:`, shape);
  }
  static ɵfac = function DotLinkService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkService)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1.DotComponentService), i0.ɵɵinject(DOT_LINK_MODULE_CONFIGURE, 8));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotLinkService,
    factory: DotLinkService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: i1.DotComponentService
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [DOT_LINK_MODULE_CONFIGURE]
    }]
  }], null);
})();
class DotLinksDirective {
  _link;
  set fromSelector(shape) {
    this._link.add(shape);
    this._linksClass.set('dot-links-' + shape + 's');
  }
  _linksClass;
  constructor(_link, elementRef) {
    this._link = _link;
    this._linksClass = new ClassSwitch(elementRef.nativeElement);
  }
  static ɵfac = function DotLinksDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinksDirective)(i0.ɵɵdirectiveInject(DotLinkService), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotLinksDirective,
    selectors: [["", "dotLinks", ""]],
    inputs: {
      fromSelector: [0, "dotLinks", "fromSelector"]
    },
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinksDirective, [{
    type: Directive,
    args: [{
      selector: '[dotLinks]',
      standalone: false
    }]
  }], () => [{
    type: DotLinkService
  }, {
    type: i0.ElementRef
  }], {
    fromSelector: [{
      type: Input,
      args: ['dotLinks']
    }]
  });
})();
class DotLinkComponent {
  _zone;
  _link;
  _$shape;
  _$color;
  _$up;
  alias;
  shape;
  up;
  active;
  activated = new EventEmitter();
  innerHTML;
  textContent;
  _host;
  _directives;
  constructor(_zone, _link, _$shape, _$color, _$up, elementRef) {
    this._zone = _zone;
    this._link = _link;
    this._$shape = _$shape;
    this._$color = _$color;
    this._$up = _$up;
    this._host = elementRef.nativeElement;
    this._directives = new Bulk([_$shape, _$color, _$up]);
    _$shape.shapeService = _link;
    _$shape.shapePrefix = 'link_';
    if (this._host.tagName === 'BUTTON' && !this._host.getAttribute('type')) {
      this._host.setAttribute('type', 'button');
    }
  }
  ngAfterContentInit() {
    const {
      _link: {
        configure
      }
    } = this;
    const zoneName = this._zone.getName(this._host);
    if (!zoneName) {
      return;
    }
    const zone = configure.zones[zoneName];
    if (!zone) {
      return;
    }
    this._directives.set('zone', zone);
  }
  ngOnChanges(changes) {
    for (let property in changes) {
      if (!changes.hasOwnProperty(property)) {
        continue;
      }
      this[property] = changes[property].currentValue;
    }
    const {
      _$shape,
      _$color,
      _$up
    } = this;
    if ('alias' in changes) {
      const alias = this._link.configure.aliases[this.alias];
      this._directives.set('alias', alias);
      return;
    }
    if ('shape' in changes) {
      _$shape.change('shape', changes);
    }
    if ('color' in changes) {
      _$color.change('color', changes);
    }
    if ('up' in changes) {
      _$up.change('up', changes);
    }
  }
  _onMouseEnter() {
    this._host.classList.add('_mouse');
  }
  _onMouseLeave() {
    this._host.classList.remove('_mouse');
  }
  _onClick() {
    this._host.blur();
  }
  static ɵfac = function DotLinkComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkComponent)(i0.ɵɵdirectiveInject(i1$1.DotZoneService), i0.ɵɵdirectiveInject(DotLinkService), i0.ɵɵdirectiveInject(i3.DotShapeDirective, 1), i0.ɵɵdirectiveInject(i4.DotColorDirective, 1), i0.ɵɵdirectiveInject(i5.DotUpDirective, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLinkComponent,
    selectors: [["", "dot-link", ""]],
    hostAttrs: [1, "dot-link"],
    hostVars: 2,
    hostBindings: function DotLinkComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mouseenter", function DotLinkComponent_mouseenter_HostBindingHandler() {
          return ctx._onMouseEnter();
        })("mouseleave", function DotLinkComponent_mouseleave_HostBindingHandler() {
          return ctx._onMouseLeave();
        })("click", function DotLinkComponent_click_HostBindingHandler() {
          return ctx._onClick();
        });
      }
      if (rf & 2) {
        i0.ɵɵclassProp("_active", ctx.active);
      }
    },
    inputs: {
      color: "color",
      ripple: "ripple",
      up: "up",
      upTo: "upTo",
      upColor: "upColor",
      tip: "tip",
      alias: "alias",
      shape: "shape",
      active: "active",
      innerHTML: "innerHTML",
      textContent: "textContent"
    },
    outputs: {
      activated: "activated"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([]), i0.ɵɵHostDirectivesFeature([{
      directive: i3.DotShapeDirective,
      inputs: ["shape", "shape"]
    }, {
      directive: i4.DotColorDirective,
      inputs: ["color", "color"]
    }, {
      directive: i6.DotRippleDirective,
      inputs: ["ripple", "ripple"]
    }, {
      directive: i5.DotUpDirective,
      inputs: ["up", "up", "upTo", "upTo", "upColor", "upColor"]
    }, {
      directive: i7.DotTipDirective,
      inputs: ["tip", "tip", "delay", "tipDelay"]
    }]), i0.ɵɵNgOnChangesFeature],
    attrs: _c0,
    ngContentSelectors: _c1,
    decls: 3,
    vars: 1,
    consts: [[1, "dot-link-area", 3, "innerHTML"], [1, "dot-link-area", 3, "textContent"], [1, "dot-link-area"]],
    template: function DotLinkComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, DotLinkComponent_Conditional_0_Template, 1, 1, "span", 0)(1, DotLinkComponent_Conditional_1_Template, 1, 1, "span", 1)(2, DotLinkComponent_Conditional_2_Template, 2, 0, "span", 2);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.innerHTML ? 0 : ctx.textContent ? 1 : 2);
      }
    },
    styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}:root{--link-borders:none;--link-gap:8px;--link-back-deg:90deg;--link-text:currentColor;--link-back:inherit;--link-radius:8px;--link-height:auto;--link-pads:0 .625em;--link-active-back:inherit;--link-active-text:inherit;--link-active-borders:inherit;--link-active-outlines:inherit}.dot-link{margin:0;padding:0;box-sizing:border-box;height:var(--link-height);font-size:1rem;cursor:pointer;color:var(--link-text);border:var(--link-borders);border-radius:var(--link-radius,var(--radius,0));background:var(--link-back);white-space:nowrap}.dot-link:not([hidden]){display:inline-block}.dot-link>.dot-link-area,.dot-link>span:not([class]){display:inline-flex;align-items:center;padding:var(--link-pads);white-space:nowrap;overflow:hidden}.dot-link:focus{outline:var(--link-focus-outlines,inherit)}.dot-link[disabled],.dot-link[disabled].active,.dot-link[disabled]:hover{cursor:not-allowed;opacity:.32}.dot-link._active{cursor:progress}*+.dot-link:not(:first-child){margin-left:var(--link-gap)}.dot-link:focus{--link-focus-outlines:currentColor solid 2px}.dot-link:hover{--link-back:var(--t4a)}.dot-link._main{--link-text:var(--m);--link-react-back:var(--m96)}.dot-link._main:hover{--link-back:var(--m4a)}.dot-link._point{--link-text:var(--p);--link-react-back:var(--p96)}.dot-link._point:hover{--link-back:var(--p4a)}.dot-link._warn{--link-text:var(--w);--link-react-back:var(--w96)}.dot-link._warn:hover{--link-back:var(--w4a)}.dot-link[disabled]{--link-text:inherit;--link-back:inherit;--link-react-back:inherit;--link-react-text:inherit}\n", ".dot-link._mouse:focus{outline:none!important}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkComponent, [{
    type: Component,
    args: [{
      selector: '[dot-link]',
      template: `
		@if (innerHTML) {
			<span class="dot-link-area" [innerHTML]="innerHTML"></span>
		} @else if (textContent) {
			<span class="dot-link-area" [textContent]="textContent"></span>
		} @else {
			<span class="dot-link-area"><ng-content></ng-content></span>
		}
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-link',
        '[class._active]': 'active'
      },
      providers: [],
      hostDirectives: [{
        directive: DotShapeDirective,
        inputs: ['shape']
      }, {
        directive: DotColorDirective,
        inputs: ['color']
      }, {
        directive: DotRippleDirective,
        inputs: ['ripple']
      }, {
        directive: DotUpDirective,
        inputs: ['up', 'upTo', 'upColor']
      }, {
        directive: DotTipDirective,
        inputs: ['tip', 'delay:tipDelay']
      }],
      inputs: ['color', 'ripple', 'up', 'upTo', 'upColor', 'tip'],
      standalone: false,
      styles: ["@keyframes link-gd-right{to{background-position-x:-200%}}:root{--link-borders:none;--link-gap:8px;--link-back-deg:90deg;--link-text:currentColor;--link-back:inherit;--link-radius:8px;--link-height:auto;--link-pads:0 .625em;--link-active-back:inherit;--link-active-text:inherit;--link-active-borders:inherit;--link-active-outlines:inherit}.dot-link{margin:0;padding:0;box-sizing:border-box;height:var(--link-height);font-size:1rem;cursor:pointer;color:var(--link-text);border:var(--link-borders);border-radius:var(--link-radius,var(--radius,0));background:var(--link-back);white-space:nowrap}.dot-link:not([hidden]){display:inline-block}.dot-link>.dot-link-area,.dot-link>span:not([class]){display:inline-flex;align-items:center;padding:var(--link-pads);white-space:nowrap;overflow:hidden}.dot-link:focus{outline:var(--link-focus-outlines,inherit)}.dot-link[disabled],.dot-link[disabled].active,.dot-link[disabled]:hover{cursor:not-allowed;opacity:.32}.dot-link._active{cursor:progress}*+.dot-link:not(:first-child){margin-left:var(--link-gap)}.dot-link:focus{--link-focus-outlines:currentColor solid 2px}.dot-link:hover{--link-back:var(--t4a)}.dot-link._main{--link-text:var(--m);--link-react-back:var(--m96)}.dot-link._main:hover{--link-back:var(--m4a)}.dot-link._point{--link-text:var(--p);--link-react-back:var(--p96)}.dot-link._point:hover{--link-back:var(--p4a)}.dot-link._warn{--link-text:var(--w);--link-react-back:var(--w96)}.dot-link._warn:hover{--link-back:var(--w4a)}.dot-link[disabled]{--link-text:inherit;--link-back:inherit;--link-react-back:inherit;--link-react-text:inherit}\n", ".dot-link._mouse:focus{outline:none!important}\n"]
    }]
  }], () => [{
    type: i1$1.DotZoneService
  }, {
    type: DotLinkService
  }, {
    type: i3.DotShapeDirective,
    decorators: [{
      type: Host
    }]
  }, {
    type: i4.DotColorDirective,
    decorators: [{
      type: Host
    }]
  }, {
    type: i5.DotUpDirective,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    alias: [{
      type: Input
    }],
    shape: [{
      type: Input
    }],
    up: [{
      type: Input
    }],
    active: [{
      type: Input
    }],
    activated: [{
      type: Output
    }],
    innerHTML: [{
      type: Input
    }],
    textContent: [{
      type: Input
    }],
    _onMouseEnter: [{
      type: HostListener,
      args: ['mouseenter']
    }],
    _onMouseLeave: [{
      type: HostListener,
      args: ['mouseleave']
    }],
    _onClick: [{
      type: HostListener,
      args: ['click']
    }]
  });
})();

/**
 * DotLink
 * the `css-dot` link implementor of angular
 *
 * @description
 * available:
 * - [dot-link]
 * - [dotLinks]
 */
class DotLinkModule {
  /**
   * DotLinkModule with Configure - __Import to AppModule__
   * @param configure
   */
  static forRoot(configure) {
    return {
      ngModule: DotLinkModule,
      providers: [{
        provide: DOT_LINK_MODULE_CONFIGURE,
        useValue: configure
      }]
    };
  }
  static ɵfac = function DotLinkModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLinkModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotLinkModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLinkModule, [{
    type: NgModule,
    args: [{
      declarations: [DotLinkComponent, DotLinksDirective],
      imports: [CommonModule],
      exports: [DotLinkComponent, DotLinksDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DOT_LINK_MODULE_CONFIGURE, DotLinkComponent, DotLinkModule, DotLinkService, DotLinksDirective };
